const $_cd = elem => document.querySelector(elem);

const countdown = function(_config) {
  let epoch = $_cd(_config.target).getAttribute('data-epoch');

  let months = [31, new Date().getFullYear() % 4 == 0 ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  let dateNow = new Date();
  let dayNow = dateNow.getDate();
  let monthNow = dateNow.getMonth() + 1;
  let yearNow = dateNow.getFullYear();
  let hourNow = dateNow.getHours();
  let minNow = dateNow.getMinutes();
  let count_day = 0, count_hour = 0, count_min = 0;
  let count_day_isSet = false;
  let isOver = false;

  // Set the date we're counting down to
  const countDownDate = epoch * 1000;

  console.log(countDownDate)
  
  const updateTime = () => {
    // Get todays date and time
    const now = new Date().getTime();

    // Find the distance between now an the count down date
    const distance = countDownDate - now;

    // Time calculations for days, hours, minutes and seconds
    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    requestAnimationFrame(updateTime);

    if ($_cd(_config.target+' .day .num')){
      $_cd(_config.target+' .day .num').innerHTML = addZero(days);
      $_cd(_config.target+' .hour .num').innerHTML = addZero(hours);
      $_cd(_config.target+' .min .num').innerHTML = addZero(minutes);
      $_cd(_config.target+' .sec .num').innerHTML = addZero(seconds);
    }

    // If the count down is over, write some text
    if (distance < 0) {
      $_cd(_config.expire).innerHTML = "";
    }
  }

  updateTime();
}

const addZero = (x) => (x < 10 && x >= 0) ? "0"+x : x;